// hooks/deals-selectors.ts (NEW)
import { useDealContext } from '@/contexts/deal-provider';
import { dealStore } from '@/models/stores';

export function useDealsShortIds(): string[] {
  const { hubPathIdentifier } = useDealContext();
  return hubPathIdentifier ? dealStore.shortIdsByHub(hubPathIdentifier) : [];
}

export function useDealsListData() {
  const { hubPathIdentifier } = useDealContext();
  return hubPathIdentifier
    ? dealStore.dealsListByStatus(hubPathIdentifier)
    : null;
}

export function useDealByShortId(shortId?: string | null) {
  if (!shortId) return null;
  return dealStore.getByShortId(shortId) ?? null;
}

export function useDealsForHub() {
  const { hubPathIdentifier } = useDealContext(); // thin provider
  return hubPathIdentifier
    ? dealStore.getDealsByHubPathId(hubPathIdentifier)
    : [];
}

export function useCurrentShortId() {
  const { currentShortId } = useDealContext();
  return currentShortId;
}
